import { render, staticRenderFns } from "./GestorList.vue?vue&type=template&id=0a6b8934"
import script from "./GestorList.vue?vue&type=script&lang=js"
export * from "./GestorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports